import * as React from 'react';

import CoBrandingPartnerLogos from 'bundles/unified-description-page-common/components/shared/CoBrandingPartnerLogos';
import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

const isNavPlacement = false;

const HeroCoBrandingPartnerLogos = ({ partners }: { partners: PartnerFragment[] }) => (
  <CoBrandingPartnerLogos partners={partners} isNavPlacement={isNavPlacement} />
);

export default HeroCoBrandingPartnerLogos;
